import { Component, ChangeDetectorRef, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { Observable, of } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService } from '@services/localization.service';
import { TranslateService } from '@services/translate.service';
import { UserHelper } from '@helpers/user.helper';
import { Location } from '@angular/common';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { WebWorkerService } from '../../../modules/workers/web-worker.service';
import { AppTimerService } from '@services/app-timer.service';
import { oddComboListType, SportOddModel } from '@components/fixture/favorites/favorites.model';
import { sportsSvgList } from '@app/constants/svgUrl.constant';

@Component({
  selector: 'sport-live-match-component',
  templateUrl: './sport-live-match-component.html',
  providers: [AppTimerService],
})
export class SportLiveMatchComponent implements OnChanges {
  public sportOddType: SportOddModel = new SportOddModel({});
  public __ResultLiveData: Observable<any>;
  public sportsSvgList = sportsSvgList;
  constructor(
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    public _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public _LZ: LocalizationService,
    private cdRef: ChangeDetectorRef,
    private _SignalRService: SignalrServiceLegacy,
    private _webWorkerService: WebWorkerService,
    private _location: Location,
    private _TimerService: AppTimerService
  ) {}
  @Input() liveMatchList: any;
  @Input() _selectedOdds: any;
  @Input() oddComboSelected: number[];
  @Input() oddComboSelectedMarketing: oddComboListType[];
  @Output() changeOddLiveMarketing: EventEmitter<{ event: any; index: number; sportId: number }> = new EventEmitter<{ event: any; index: number; sportId: number }>();
  @Output() defaultOddLiveMarketing: EventEmitter<{ event: any; selectComboOdd: number[]; sportId: number }> = new EventEmitter<{
    event: any;
    selectComboOdd: number[];
    sportId: number;
  }>();
  ngOnChanges(changes: SimpleChanges) {
    if (changes?.liveMatchList?.firstChange) {
      this.sportOddType = new SportOddModel({
        sportId: this.liveMatchList.SportId,
        rowCount: 4,
      });
      this.__ResultLiveData = of(this.liveMatchList.matchList);
      if (!this.oddComboSelected) {
        this.defaultOddLiveMarketing.emit({
          event: this.sportOddType.defaultSelectionOdd(),
          selectComboOdd: this.sportOddType.oddLiveMarketing,
          sportId: this.liveMatchList.SportId,
        });
      }
    }
  }

  getResponsiveOddShow(indexOddOrder) {
    switch (indexOddOrder) {
      case 1:
        return this._UiHelper.isResponsiveRules(['s']);
      case 2:
        return this._UiHelper.isResponsiveRules(['xl']);
      case 3:
        return this._UiHelper.isResponsiveRules(['xxl']);
      default:
        return true;
    }
  }

  changeOddLiveMarketingAction(event: any, index: number) {
    this.changeOddLiveMarketing.emit({
      event: event,
      index,
      sportId: this.liveMatchList.SportId,
    });
  }

  public sportLiveTrackById(index: number, item: any) {
    return index;
  }
}
